import {
    CSRF,
    DateFormat,
    formDataToObject,
    getData,
    getDataFormToObject,
    getDate,
    getElement,
    isDate,
    resetFilter,
} from "../../../helpers";
import { Dt } from "../../../plugins/datatable";

class LedgeSalesModule extends HTMLElement {
    connectedCallback() {
        this.sales();
    }

    async sales() {
        const DtElement = getElement("[data-table=dtSales]", this);
        const BtnSearch = getElement("[name=search]", this);
        const BtnReset = getElement("[name=reset]", this);
        const Form = getElement("[name=filter]", this);

        let filter = formDataToObject(Form);

        // Start DataTable
        let configDt = {
            processing: true, // Procesar ajax
            serverSide: true, // Mejorar velocidad ajax registros por página
            searching: false,
            scrollY: "400px", // Define la altura de desplazamiento para el cuerpo de la tabla
            scrollCollapse: true, // Permite que el contenido colapse dentro del área definida
            fixedHeader: true, // Mantiene el encabezado visible al hacer scroll
        };

        configDt.ajax = {
            url: getData("ledgerSalesUrlDt"),
            type: "POST",
            data: function (data) {
                // data.projects = filter.projects;
                data.startDate = filter.startDate;
                data.endDate = filter.endDate;
                data.type = filter.type;
                data.isp = filter.isp;
            },
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", CSRF);
            },
        };

        // Columnas del AJAX
        configDt.columns = [
            { data: "DT_RowIndex", width: "3%", className: "text-center" },
            // {
            //     data: "date",
            //     width: "7%",
            //     render: (data, type, row, meta) => {
            //         if (isDate(data)) {
            //             let date = getDate(data);
            //             return date.format(DateFormat);
            //         } else {
            //             return data;
            //         }
            //     },
            // },
            {
                data: "date_invoice",
                width: "7%",
                render: (data, type, row, meta) => {
                    if (isDate(data)) {
                        let date = getDate(data);
                        return date.format(DateFormat);
                    } else {
                        return data;
                    }
                },
            },
            { data: "ref_invoice" },
            { data: "cif" },
            { data: "customer" },
            { data: "tax_base", className: "text-end" },
            { data: "isp", className: "text-center" },
            { data: "tax", className: "text-end" },
            { data: "total_tax", className: "text-end" },
            { data: "withholdings", className: "text-end" },
            { data: "total_withholdings", className: "text-end" },
            { data: "total", className: "text-end" },
            // { data: "project" },
        ];

        configDt.footerCallback = function (row, data, start, end, display) {
            var api = this.api();
            var json = api.ajax.json(); // Obtener los datos JSON devueltos del servidor

            if (json?.totals && api.column(0).footer()) {
                api.column(5).footer().textContent = json.totals.totalBase;
                api.column(8).footer().textContent = json.totals.totalTax;
                api.column(10).footer().textContent =
                    json.totals.totalWithholdings;
                api.column(11).footer().textContent = json.totals.total;
            }

            // ── Nuevo: pintar desglose por tipo IVA ──
            if (json?.byTaxType?.length) {
                const container = document.querySelector("#tax-breakdown");
                if (!container) return;

                const rows = json.byTaxType
                    .map(
                        (row) => `
            <tr>
                <td>${row.tax_pct}${row.isp ? ' <span class="badge bg-warning text-dark">ISP</span>' : ""}</td>
                <td class="text-end">${row.tax_base}</td>
                <td class="text-end">${row.tax_amount}</td>
            </tr>
        `,
                    )
                    .join("");

                container.innerHTML = `
            <table class="table table-sm table-bordered">
                <thead class="table-light">
                    <tr>
                        <th>IVA</th>
                        <th class="text-end">Base imponible</th>
                        <th class="text-end">Cuota IVA</th>
                    </tr>
                </thead>
                <tbody>${rows}</tbody>
            </table>
        `;
            }
        };

        const DtAp = new Dt(configDt);
        let T = await DtAp.dataTable(DtElement);
        // End DataTable

        //Acciones
        BtnSearch?.addEventListener("click", () => {
            filter = getDataFormToObject(Form, filter);

            T.ajax.reload();
        });

        BtnReset?.addEventListener("click", () => {
            filter = formDataToObject(Form);

            resetFilter(Form, filter);

            T.ajax.reload();
        });
    }
}

window.customElements.define("ledgersales-module", LedgeSalesModule, {
    extends: "section",
});
